import { Logo } from '@/components/brand/Logo'

/** Sticky brand mark at the top of the sidebar; click scrolls back to the top. */
export function LogoHomeLink() {
  return (
    <a
      href="#"
      aria-label="Back to top"
      onClick={(event) => {
        event.preventDefault()
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }}
      className="block transition-opacity hover:opacity-70"
    >
      <Logo size="small" width={64} />
    </a>
  )
}
